@use "../../scss/breakpoints";
@use "../../scss/colors";

$max-content-width: 1152px;

.welcomeFooter {
	max-width: $max-content-width;
	margin: 48px auto 10px auto;
	border-top: 1px solid colors.$nordic_light_grey;
	padding: 48px 0 80px 0;

	.links {
		display: flex;
		flex-direction: row;
		justify-content: space-around;

		@include breakpoints.md-down {
			flex-direction: column;
		}

		.social {
			display: flex;
			justify-content: space-between;
			list-style-type: none;
			padding-left: 0;
			width: 200px;

			@include breakpoints.md-down {
				margin: 10px auto;
			}

			li {
				a {
					align-items: center;
					background-color: colors.$nordic_med_grey;
					border-radius: 50%;
					display: flex;
					height: 32px;
					justify-content: center;
					width: 32px;

					img {
						height: 16px;
						width: 16px;
					}

					&:hover {
						background-color: colors.$nordic_blue;
					}
				}
			}
		}

		.nordic {
			align-items: center;
			display: flex;
			flex: 1;
			gap: 20px;
			justify-content: center;
			list-style-type: none;
			margin: 0;
			padding: 0;

			@include breakpoints.md-down {
				margin: 10px auto;
			}

			li {
				a {
					color: colors.$nordic_dark_grey;
					font-size: 14px;
					text-decoration: none;

					&:hover {
						color: colors.$nordic_lake;
						text-decoration: underline;
					}
				}
			}
		}
	}
	.copyright {
		align-items: center;
		display: flex;
		font-size: 14px;
		justify-content: flex-end;

		@include breakpoints.md-down {
			justify-content: center;
		}
	}
}
